import { observer } from "mobx-react";
import React from "react";
import Button from "./Button";

// style toolbar buttons
@observer
class ToolbarButton extends React.Component {
  render() {
    const { ...props } = this.props;
    return <Button {...props} />;
  }
}

export default ToolbarButton;
